import React from 'react'
import { OPERATION_OPTIONS } from '@/utils/constants'
import GoogleIcon from '@wiggui/ds/GoogleIcon'
import Checkbox from '@wiggui/ds/Checkbox'

interface IProps {
  operationType?: string
  onChangeOperationType: (value: string) => void
}
export const OperationTypes = ({
  operationType,
  onChangeOperationType
}: IProps) => {
  const onCheckboxChange = (value: boolean, name?: string) => {
    onChangeOperationType(name || '')
  }
  return (
    <>
      {OPERATION_OPTIONS.map(({ value, label, icon }) => {
        const isChecked = operationType === value
        return (
          <Checkbox
            key={label}
            name={value}
            id={value}
            type="checkbox"
            as="button"
            gap="gap-3"
            items="start"
            justify="between"
            containerClassName={`flex-row-reverse h-[86px] md:h-auto w-full rounded-xl p-4 outline-none [&>svg]:hidden ${
              isChecked
                ? '!border-2 border-notif-blue !bg-notif-blue-01'
                : 'border border-surface-strokes bg-white'
            }`}
            isChecked={isChecked}
            onChange={onCheckboxChange}
            label={
              <div className="flex flex-col items-start md:flex-row gap-1">
                <GoogleIcon
                  className={`text-2xl font-bold leading-6 ${
                    isChecked ? 'text-notif-blue' : 'text-primary'
                  }`}
                  name={icon}
                />
                {label && (
                  <p
                    className={`text-[15px] ${
                      isChecked ? 'text-notif-blue font-bold' : 'text-primary'
                    }`}
                  >
                    {label}
                  </p>
                )}
                {isChecked && (
                  <GoogleIcon
                    className="absolute right-[17px] top-3 font-extrabold text-lg text-white"
                    name="check"
                  />
                )}
              </div>
            }
            inputClassName="!min-w-[20px] !min-h-[20px] !max-h-[20px] !w-5 h-5 !p-2 !rounded-full checked:!bg-notif-blue checked:!border-notif-blue"
          />
        )
      })}
    </>
  )
}
